module.exports = __webpack_public_path__ + "static/media/cert_image.b5a30db4.png";